/*eslint-disable */
const $ = window.jQuery = require('jquery');

import bucketTreeView from '../paper-move-to-folder/tree-view-bucket.vue';
import { bus } from '@/main';
import { mapGetters } from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'paper-upload-in-folder',
  components: {
    'bucket-tree-view' : bucketTreeView
  },
  props: ['paperID'],
  data () {
    return {
      submitted:false,
      name:'',
      addNewBucketState:false,
      bucketListDetails:null,
      bucketListResults:[],
      selectedFolderId:''
    }
  },
  computed: {
    ...mapGetters([
      'getBucketListOfAwerackGetters',
    ]),
    getBucketListDetailsFun(){
      this.bucketListDetails = this.$store.getters.getBucketListOfAwerackGetters.data;
      return;
    },
    setIntialStateOfBucket(){
      if(this.bucketListDetails){
        this.bucketListResults = this.bucketListDetails.results;
      }
    }
  },
  mounted(){
    this.getBucketListDetailsFun
    this.setIntialStateOfBucket
    bus.$on('getSelectFolderID', (data) => {
      this.selectedFolderId = data
    })
  },
  methods: {
    getPaperPileListAgain() {
      this.$store.dispatch('getAllPaperPileFun')
    },
    movePaperInParentFolder(){
      this.isSubmitted = true
      let payload = {
        pdf_paper:this.paperID,
        parent:this.selectedFolderId,
        is_folder:false
      }
      this.$store.dispatch('createBucketOfAwerackDetailsFun', payload).then((res) => {
        this.isSubmitted = false
        this.getPaperPileListAgain();
        this.closeAllPopupMethod();
        toast.success(res.data.msg);
      }).catch((err)=>{
        this.isSubmitted = false
        this.paperMoverPopupClosed()
        toast.error(err.data.user_msg || err.data.msg);
      })
      return;
    },
    createNewSubBucketBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            name:this.name,
            is_folder:true
          }
          this.$store.dispatch('createBucketOfAwerackDetailsFun', data)
            .then((res) => {  
              let payload = {
                pdf_paper:this.paperID,
                parent:res.data.data.id,
                is_folder:false
              }
              this.$store.dispatch('createBucketOfAwerackDetailsFun', payload).then((res) => {
                toast.success(res.data.msg);
                this.$store.dispatch('getBucketListOfAwerackFun')
                this.getPaperPileListAgain();
                this.closeAllPopupMethod();
                this.submitted = false
              })
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    closeAllPopupMethod(){
      bus.$emit('savePaperPopupStateBus', false);
      bus.$emit('addPaperPilePopupStateBus', false);
      bus.$emit('uploadPaperStateBus', false);
      document.body.classList.remove('body_right_scroll_remove')
    },
    closeSelfPopupMethod(){
      bus.$emit('paperSavedInFolderStateBus', false);
    },
    addNewFolderMethod(){
      this.addNewBucketState = true
    },
    backFolderListMethod(){
      this.addNewBucketState = false
    }
  },
  watch:{
    getBucketListDetailsFun(){
      return this.$store.getters.getBucketListOfAwerackGetters;
    },
    setIntialStateOfBucket(){
      if(this.bucketListDetails){
        this.bucketListResults = this.bucketListDetails.results;
      }
    }
  }
}